<template>
  <div>
    <div v-if="isRequestSubmitted" class="section__login section__form">
      <h2>Please check your email to continue</h2>
      <p>
        We&apos;ve sent you an email with your username and instructions on
        how to reset your password
      </p>
      <router-link to="login" class="btn">Login</router-link>
    </div>
    <div v-else class="section__login section__form">
      <Loading v-if="isSubmitting" />
      <h2>I need help logging in</h2>
      <p>
        Enter your email address and we'll send you an email with instructions on how to reset your password
      </p>
      <form action="#" @submit.prevent="submitRequest">
        <transition name="fade">
          <p v-if="error.global" class="error-message">{{error.global}}</p>
        </transition>
        <div>
          <label for="email">Your email address</label>
          <input 
            type="email" 
            id="email" 
            name="email" 
            placeholder="Email address" 
            v-model.lazy.trim="email"  
            :disabled="isSubmitting"
            autofocus>
          <transition name="fade">
            <p v-if="error.email" class="error-message">{{error.email}}</p>
          </transition>
        </div>
        <div>
          <button type="submit" :disabled="isSubmitting" class="btn">Continue</button>
        </div>
      </form>
      <p class="link__style4">
        <router-link to="login" class="link">Try logging in again</router-link>
      </p>
    </div>
    <!-- show message -->
  </div>
</template>

<script>
import { validateEmail } from '@/helpers/helpers';
import { resetPasswordByEmail } from '@/helpers/UserAPI';
import Loading from '@/components/elements/Loading';

export default {
  name: 'ResetPassword',
  data: function() {
    return {
      email: '',
      isSubmitting: false,
      isRequestSubmitted: false,
      error: {
        email: '',
        global: ''
      }
    };
  },
  components: {
    Loading
  },
  methods: {
    submitRequest: async function() {
      this.isSubmitting = true;
      if(!this.email) {
        this.isSubmitting = false;
        this.error.email = 'Email address is required';
        return;
      }

      const res = await resetPasswordByEmail(this.email);
      this.isSubmitting = false;
      if(res !== undefined) {
        this.isRequestSubmitted = true;
      } else {
        this.error.global = 'Please try again later!';
      }
    }
  },
  watch: {
    email: function() {
      if(!validateEmail(this.email)) {
        this.error.email = 'Email address is invalid';
      } else {
        this.error.email = '';
      }
    },
    $route(to, from) {
      console.log('====== watch $route ======');
      console.info(to);
      console.info(from);
    }
  },
  created() {
    console.log('======= view created ========');
    if(this.$route.query.token != '') {
      //view control
    }
  }
}
</script>

<style lang="sass">
  .link__style4 {
    margin-top: 20px;

    a{
      color: $tinybeans-pink;
      font-size: 16px;
      font-weight: bold;
      font-family: "Open Sans", sans-serif;
      text-decoration: none;

      &:hover,
      &:focus {
        color: $candlelight;
      }
    }
  }
</style>